import {routes} from "../../App";
import './styles.css';
import {Link} from "react-router-dom";
import {useEffect} from "react";

export default function ConfigRoutes() {

    useEffect(() => {
        setTimeout(() => {
            document.body.style.overflow = 'scroll'
        }, 1000)
    }, [])
    return (
        <div className="container-ado-routes">
            {routes.map(route => (
                <Link to={route.path + route.innerPath} className="card-ado-routes" key={route.path}>
                    <h3>{route.name}</h3>
                    {route.description && (
                        <span>{route.description} 2</span>
                    )}
                </Link>
            ))}
        </div>
    )
}
